import Component from 'components/pages/ContactUs/ContactUs.qmee';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('contact', {
  withoutHeaderOnMobile: true,
  withoutFooterOnMobile: true,
});
export default buildPage(Component, {
  requiresAuthentication: false,
  metaData: {
    title: 'Contact Us',
    description: 'Contact Us Page',
  },
});
